import readingPaneStore from '../store/Store';
import shouldShowUnstackedReadingPane from 'owa-mail-store/lib/utils/shouldShowUnstackedReadingPane';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';

export default action('clearReadingPaneStore')(function clearReadingPaneStore(
    listViewType: ReactListViewType
) {
    if (listViewType === ReactListViewType.Message || shouldShowUnstackedReadingPane()) {
        readingPaneStore.itemReadingPaneViewState = null;
    } else if (listViewType === ReactListViewType.Conversation) {
        readingPaneStore.conversationReadingPaneViewState = null;
    }
});
